import TagManager from 'react-gtm-module'

export const useAnalyticsManager = () => {
  return {
    trigger(eventName: string, args: any) {
      TagManager.dataLayer({ dataLayer: { event: eventName, ...args } })
    },
  }
}
